import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as mobile from './types';

const mutations = {
  // 통신사 목록
  [mobile.SET_MOBILE_TELECOMS](state, data) {
    state.mobileTelecoms = data;
  },
  // 단말 카테고리 목록
  [mobile.SET_MOBILE_CATEGORY](state, data) {
    state.mobileCategory = data;
  },
  // 단말 목록
  [mobile.SET_MOBILE_DEVICE](state, data) {
    state.mobileDevice = data;
  },
  // 단말 정보
  [mobile.SET_MOBILE_DEVICE_DETAIL](state, data) {
    state.mobileDeviceDetail = data;
  },
  // 요금 카테고리 정보
  [mobile.SET_MOBILE_PLAN_CATEGORY](state, data) {
    state.mobilePlanCategory = data;
  },
  // 요금 목록
  [mobile.SET_MOBILE_PLANS](state, data) {
    state.mobilePlans = data;
  },
  // 요금 정보
  [mobile.SET_MOBILE_PLAN_DETAIL](state, data) {
    state.mobilePlanDetail = data;
  },
  // 요청 목록
  [mobile.SET_MOBILE_REQUEST_LIST_ING](state, data) {
    state.mobileRequestListIng = data;
  },

  // 요청 목록
  [mobile.SET_MOBILE_REQUEST_LIST_END](state, data) {
    state.mobileRequestListEnd = data;
  },

  // 요청 상세정보
  [mobile.SET_MOBILE_REQUEST_VIEW](state, data) {
    state.mobileRequestView = data;
  },

  // 견적수신함
  [mobile.SET_MOBILE_ESTIMATE_LIST](state, data) {
    state.mobileEstimateList = data;
  },

  // 견적수신함
  [mobile.SET_MOBILE_ESTIMATE_GROUP_LIST](state, data) {
    state.mobileEstimateGroupList = data;
  },

  // 견적수신함 상세
  [mobile.SET_MOBILE_ESTIMATE_DETAIL](state, data) {
    state.mobileEstimateDetail = data;
  },

  // 견적수신함 미리보기
  [mobile.SET_MOBILE_ESTIMATE_PREVIEW](state, data) {
    state.mobileEstimatePreview = data;
  },

  // 부가서비스 목록
  [mobile.SET_MOBILE_SERVICE_LIST](state, data) {
    state.mobileServiceList = data;
  },

  // 방문약속 상세
  [mobile.SET_MOBILE_PROMISE](state, data) {
    state.mobilePromise = data;
  },

  // 방문약속 목록
  [mobile.SET_MOBILE_PROMISE_LIST](state, data) {
    state.mobilePromiseList = data;
  },

  // 새로운 견적 건수
  [mobile.SET_MOBILE_ESTIMATE_NEW_CNT](state, data) {
    state.mobileEstimateNewCnt = data;
  },

  // 새로운 방문약속 건수
  [mobile.SET_MOBILE_PROMISE_NEW_CNT](state, data) {
    state.mobilePromiseNewCnt = data;
  },

  // 부가서비스 목록
  [mobile.SET_MOBILE_INSURANCE_LIST](state, data) {
    state.mobileInsuranceList = data;
  },

  // 채팅방 휴대폰 견적서
  [mobile.SET_MOBILE_CHAT_ESTIMATE_LIST](state, data) {
    state.mobileChatEstimateList = data;
  },

  // 새로운 신청서 건수
  [mobile.SET_MOBILE_APPLY_CNT_NEW](state, data) {
    state.mobileApplyNewCnt = data;
  },
};

export default mutations;
